<script setup lang="ts">
  import { Text } from "@ui-kit";
</script>

<template>
  <div class="order-card-item-picking-head">
    <div class="cell">
      <Text font="body-regular-12" color="secondary">{{ $t("Размер") }}</Text>
    </div>
    <div class="cell">
      <Text font="body-regular-12" color="secondary">{{ $t("Сбор") }}</Text>
    </div>
    <div class="cell">
      <Text font="body-regular-12" color="secondary">{{ $t("Факт") }}</Text>
    </div>
  </div>
</template>

<style scoped>
  .order-card-item-picking-head {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .cell {
      display: flex;
      align-items: center;
      flex: 1;
    }
  }
</style>
